import { VerticalContainer } from '@/components';
import {
    CouponRedemptionViewModel,
    TrainingProgramViewModel,
} from '@/features/profile/model/types';
import { R } from '@/features/profile/resources/ProfileResources.resx';
import { CouponRedemptionCard } from './CouponRedemptionCard';
import { TrainingProgramCard } from '@/features/profile/widgets/access/ui/TrainingProgramCard';
import { SubscriptionCard } from '@/features/profile/widgets/access/ui/SubscriptionCard';
import { SubscriptionDetailsResponse } from '@/features/profile/model/types';

type CouponRedemptionsProps = {
    couponRedemptions: CouponRedemptionViewModel[];
    trainingPrograms: TrainingProgramViewModel[];
    subscriptions: SubscriptionDetailsResponse[];
};

export const MyServices = ({
    couponRedemptions,
    trainingPrograms,
    subscriptions,
}: CouponRedemptionsProps) => {
    if (
        couponRedemptions.length === 0 &&
        trainingPrograms.length === 0 &&
        subscriptions.length === 0
    ) {
        return null;
    }

    const activeCouponRedemptions = couponRedemptions.filter((r) => r.IsActive);
    const inactiveCouponRedemptions = couponRedemptions.filter(
        (r) => !r.IsActive,
    );
    const activeTrainingPrograms = trainingPrograms.filter((tp) => tp.IsActive);
    const inactiveTrainingPrograms = trainingPrograms.filter(
        (tp) => !tp.IsActive,
    );
    const activeSubscriptions = subscriptions.filter((s) => s.IsActive);
    const inactiveSubscriptions = subscriptions.filter((s) => !s.IsActive);

    const hasActiveServices =
        activeCouponRedemptions.length > 0 ||
        activeTrainingPrograms.length > 0 ||
        activeSubscriptions.length > 0;
    const hasInactiveServices =
        inactiveCouponRedemptions.length > 0 ||
        inactiveTrainingPrograms.length > 0 ||
        inactiveSubscriptions.length > 0;

    return (
        <VerticalContainer spacing="lg" className="w-full">
            {hasActiveServices && (
                <VerticalContainer spacing="md">
                    <h3 className="text-text-primary font-semibold">
                        {R.MyServices}
                    </h3>
                    <div className="grid w-full grid-cols-1 items-stretch gap-4 lg:grid-cols-2">
                        {activeCouponRedemptions.map((couponRedemption) => (
                            <CouponRedemptionCard
                                key={couponRedemption.CouponRedemptionId}
                                couponRedemption={couponRedemption}
                            />
                        ))}
                        {activeTrainingPrograms.map((trainingProgram) => (
                            <TrainingProgramCard
                                key={trainingProgram.UserId}
                                program={trainingProgram}
                            />
                        ))}
                        {activeSubscriptions.map((subscription) => (
                            <SubscriptionCard
                                key={subscription.SubscriptionId}
                                subscription={subscription}
                            />
                        ))}
                    </div>
                </VerticalContainer>
            )}

            {hasInactiveServices && (
                <VerticalContainer spacing="md">
                    <h3 className="text-text-primary font-semibold">
                        {R.MyInactiveServices}
                    </h3>
                    <div className="grid w-full grid-cols-1 items-stretch gap-4 lg:grid-cols-2">
                        {inactiveCouponRedemptions.map((couponRedemption) => (
                            <CouponRedemptionCard
                                key={couponRedemption.CouponRedemptionId}
                                couponRedemption={couponRedemption}
                            />
                        ))}
                        {inactiveTrainingPrograms.map((trainingProgram) => (
                            <TrainingProgramCard
                                key={trainingProgram.UserId}
                                program={trainingProgram}
                            />
                        ))}
                        {inactiveSubscriptions.map((subscription) => (
                            <SubscriptionCard
                                key={subscription.SubscriptionId}
                                subscription={subscription}
                            />
                        ))}
                    </div>
                </VerticalContainer>
            )}
        </VerticalContainer>
    );
};
